import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type FavoritesState } from './types';

const initialState: FavoritesState = {
  ids: [],
  loading: false,
};

export const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    setFavoriteIds: (state, { payload }: PayloadAction<number[]>) => {
      state.ids = payload;
      state.loading = false;
    },
    addFavoriteId: (state, { payload }: PayloadAction<number>) => {
      if (!state.ids.includes(payload)) {
        state.ids.push(payload);
      }
    },
    removeFavoriteId: (state, { payload }: PayloadAction<number>) => {
      state.ids = state.ids.filter((id) => id !== payload);
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
  },
});

export const { reducer: favoritesReducer } = favoritesSlice;
